import { NotificationsState, Notification } from './notifications.model';

const reducers = {
  addNotification: (
    state: NotificationsState,
    payload: Notification
  ): NotificationsState => ({
    ...state,
    items: [...state.items, payload]
  }),
  setNotifications: (
    state: NotificationsState,
    payload: Notification[]
  ): NotificationsState => ({
    ...state,
    items: [...payload]
  }),
  removeNotification: (
    state: NotificationsState,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    payload: number
  ): NotificationsState => {
    console.log('REMOVAL NOT IMPLEMENTED YET');
    return {
      ...state
    };
  },

  markedAllAsDisplayed: (state: NotificationsState): NotificationsState => ({
    ...state,
    items: state.items.map((notification) => ({
      ...notification,
      isDisplayed: true
    }))
  })
};
export default reducers;
